import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import logo from '../assets/logo-lantmannen.png';

class Header extends Component {

  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    console.log(this.props);
  }

  goBack(){
    if(this.props.location.pathname !== "/"){
      this.props.history.goBack();
    }
  }

  render() {

    let location = this.props.location.pathname;

    return (
        <header className="header">
          <div className="header-baseline">
            <img alt="Lantmännen logga" className="header-logo" src={logo} />
            <h2 className="header-title"> Blandningsguide </h2>
            {location !== "/" && <button onClick={this.goBack} className="btn small">Tillbaka</button>}
          </div>
        </header>
    );
  }
}

export default withRouter(connect()(Header));
